/**
 * Constantes para los logos de empresas
 * Centraliza la información de logos para evitar duplicación
 */
export const COMPANY_LOGOS = [
  { name: "Microsoft", logo: "/logos/microsoft_logo.png" },
  { name: "Google Cloud", logo: "/logos/google_logo.png" },
  { name: "AWS", logo: "/logos/aws_logo.png" },
  { name: "Oracle Cloud", logo: "/logos/oracle_logo.png" },
  { name: "IBM Cloud", logo: "/logos/ibm_logo.png" },
  { name: "Salesforce", logo: "/logos/salesforce_logo.png" },
  { name: "Kubernetes", logo: "/logos/kubernetes_logo.png" },
];
